<mat-form-field appearance="outline" [class.has-value]="hasValue">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input 
    matInput 
    [autocomplete]="autocomplete" 
    [name]="name" 
    [ngxMatDatetimePicker]="pickerCustomIcon" 
    [placeholder]="placeholder" 
    [formControl]="control" 
    [min]="minDate" 
    [max]="maxDate" 
    [readonly]="false"
    (blur)="onInputBlur($event)" 
    (keydown.enter)="onInputBlur($event)" />
  <ngx-mat-datepicker-toggle matSuffix [for]="pickerCustomIcon">
    <app-enfaf-icon ngxMatDatepickerToggleIcon svgIconName="calendar-dark" iconSize="21px" />
  </ngx-mat-datepicker-toggle>
  <ngx-mat-datetime-picker
    color="primary"
    #pickerCustomIcon
    [showSpinners]="showSpinners"
    [showSeconds]="showSeconds"
    [stepHour]="stepHour"
    [stepMinute]="stepMinute"
    [stepSecond]="stepSecond"
    [touchUi]="touchUi"
    [enableMeridian]="enableMeridian"
    [disableMinute]="disableMinute"
    [hideTime]="hideTime"
  >
    <ngx-mat-datepicker-actions>
      <button mat-button ngxMatDatepickerCancel>Cancelar</button>
      <button mat-raised-button color="primary" ngxMatDatepickerApply>Aceptar</button>
    </ngx-mat-datepicker-actions>
  </ngx-mat-datetime-picker>

  @if (control && control.invalid && (control.touched || control.dirty) && errorLabel) {
    <mat-error>{{ errorLabel }}</mat-error>
  }

  @if (description && description.length > 0) {
    <mat-hint>{{ description }}</mat-hint>
  }
</mat-form-field>